import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService, private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.authService.getToken();

    let authReq = req;
    if (token) {
      // Adjuntamos el token a cada petición
      authReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        // Verificar si el error es 401 (Unauthorized)
        if (error.status === 401) {
          console.warn('Token expirado o inválido. Redirigiendo al login...');
          
          // Cerrar sesión y redirigir al login
          this.authService.logout();
          this.router.navigate(['/login']);
        }

        // Opcional: manejar otros errores
        if (error.status === 403) {
          console.warn('Acceso denegado. No tienes permisos suficientes.');
        }

        return throwError(() => error);
      })
    );
  }
}
